module.exports = __webpack_public_path__ + "1de2791b058ce7ef70cd63eaca20d9e5.png";